export const selectCompanyList = (state) => state.company.companyList;
export const selectSearchedCompany = (state) => state.company.searchedCompany;
export const selectCompanySelectedAddress = (state) => state.company.companySelectedAddress;
export const selectCreatedCompany = (state) => state.company.createdCompany;
export const selectIsCompanySearched = (state) => state.company.isCompanySearched;
export const selectCompanyPastOrders = (state) => state.company.companyPastOrders;
export const selectCompanyActiveOrders = (state) => state.company.companyActiveOrders;

export const selectCompanyAddresses = (state) => state.company.searchedCompany?.addresses;
export const selectBankNames = (state) => state.company.bankNamesList;
export const selectAccountManagers = (state) => state.company.accountManagerList; 